import { Button } from "@mui/material";
import GroupAddIcon from '@mui/icons-material/GroupAdd';

const SaveReservationGroupButton = ({ handleClick }) => {
  return (
    <Button
      onClick={handleClick}
      sx={{
        width: "fit-content",
        backgroundColor: "rgba(84, 110, 122, 1)",
        color: "#FFFFFF",
        padding: "25px",
        borderRadius: "50%",
        position: "fixed",
        bottom: "20px",
        right: "100px",
      }}
      variant="contained"
    >
      <GroupAddIcon />
    </Button>
  );
};

export default SaveReservationGroupButton;
